import { render } from "./IntegrationSection.vue?vue&type=template&id=0760b842&scoped=true"
import script from "./IntegrationSection.vue?vue&type=script&lang=js"
export * from "./IntegrationSection.vue?vue&type=script&lang=js"

import "./IntegrationSection.vue?vue&type=style&index=0&id=0760b842&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0760b842"]])

export default __exports__